// Every menu placed from a steady measure (#386, #390). Quasar places a menu (q-menu, and so q-select's list and
// q-btn-dropdown's) from its measured size (offsetWidth, offsetHeight) when it opens, 300 ms later and on scroll and
// resize. On the user's Chrome that measure wavered by a pixel while the menu stood still (241 to 243 px for a menu
// drawn 242 px wide), so a menu against its button's right edge or above it was placed a pixel off one time and moved
// back the next. The menu's own measure is read from its laid-out size instead, which held still; Quasar's placing
// (offset, limits, the screen's edges) stays its own. Applied to the v1 component before any QMenu exists (as
// qscrollarea-ios-fix.js); #386 did it for UiMenu alone, q-select's own menu kept wavering (#390)
import QMenu from 'quasar/src/components/menu/QMenu.js';;
var updatePosition = QMenu.options.methods.updatePosition;

function steadyUpdatePosition() {
  var el = this.__portal && this.__portal.$el;

  if (el && el.nodeType === 1 && !Object.prototype.hasOwnProperty.call(el, 'offsetWidth')) {
    var native = function native(side) {
      return Object.getOwnPropertyDescriptor(HTMLElement.prototype, side).get.call(el);
    }; // its laid-out size (border box: a menu is box-sizing border-box; a transform does not count, as with
    // offsetWidth), rounded up so a limit Quasar takes from it never cuts the menu by a fraction; not laid out
    // (no size in pixels): the browser's own measure


    var style = getComputedStyle(el);

    var size = function size(side) {
      var px = parseFloat(style[side === 'offsetWidth' ? 'width' : 'height']);
      return isNaN(px) ? native(side) : Math.ceil(px);
    };

    Object.defineProperty(el, 'offsetWidth', {
      configurable: true,
      get: function get() {
        return size('offsetWidth');
      }
    });
    Object.defineProperty(el, 'offsetHeight', {
      configurable: true,
      get: function get() {
        return size('offsetHeight');
      }
    });
  }

  return updatePosition.apply(this, arguments);
} // on the component's own methods too: Vue builds its options anew from them once a global mixin comes after this file


QMenu.options.methods.updatePosition = steadyUpdatePosition;
QMenu.extendOptions.methods.updatePosition = steadyUpdatePosition;
export default (function () {});